import React, { memo } from "react";
import "./SearchResult.css";
import { ErrorSharp } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Board from "@publicPortal/components/board/Board";
import validators, { ValidationResult } from "@shared/mirage/validators";
import { useState } from "react";

interface SaveSearchModalProps {
    onClose: () => void;
    handleSaveSearch: () => Promise<void>;
    isOpen: boolean;
    searchName: string;
    setSearchName: (value: string) => void;
}

const SaveSearchModal: React.FC<SaveSearchModalProps> = memo((props) => {
    const { onClose, handleSaveSearch, isOpen, searchName, setSearchName } = props;
    const [validator, setValidator] = useState<ValidationResult>({ error: "", passed: true });

    return (
        <Modal onClose={(event, reason) => handleClose(reason)} open={isOpen}>
            <Box className="modal-save-search-box">
                <Board size="small" headerText="Name your Search">
                    <Box className="modal-save-search-content-container">
                        <TextField
                            className="save-search-field"
                            id="save-search-name-field"
                            value={searchName}
                            required
                            onChange={(e) => searchNameOnChange(e.target.value)}
                            onBlur={(e) => setValidator(validators.IsStringNotEmptyValidator(e.target.value, "Enter Search Name"))}
                            label="Search Name"
                            variant="outlined"
                            error={!validator.passed}
                            helperText={getErrorMessage(validator.error)}
                        />
                        {getModalActions()}
                    </Box>
                </Board>
            </Box>
        </Modal>
    );

    function searchNameOnChange(value: string) {
        setValidator(validators.IsStringNotEmptyValidator(value, "Enter Search Name"));
        setSearchName(value);
    }

    function getModalActions() {
        return (
            <>
                <Box className="save-search-actions-container">
                    <Grid container justifyContent={"center"} sx={{ width: "100%" }}>
                        <Grid size={{ xs: 5, md: 5, xl: 5 }} textAlign="center">
                            <Button variant="outlined" type="reset" onClick={() => handleClose()}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid size={{ xs: 5, md: 5, xl: 5 }} textAlign="center">
                            <Button type="submit" variant="contained" onClick={saveSearch}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </>
        );
    }

    async function saveSearch() {
        if (!searchName) {
            return;
        }
        await handleSaveSearch();
        onClose();
    }

    function handleClose(reason?: "escapeKeyDown" | "backdropClick") {
        if (reason) {
            if (reason === "escapeKeyDown") {
                onClose();
                setValidator({ error: "", passed: true });
            }
        }
        setValidator({ error: "", passed: true });
        onClose();
    }

    function getErrorMessage(errorMessage: string | undefined) {
        return errorMessage ? (
            <span className="save-search-modal-error-message-container">
                <ErrorSharp className="error-icon"></ErrorSharp>
                <span>{errorMessage}</span>
            </span>
        ) : null;
    }
});

export default SaveSearchModal;
